var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"im-image-message",on:{"click":_vm.onPreviewImage,"longpress":_vm.onlongpress}},[_c('img',{staticClass:"image",attrs:{"src":_vm.image}})])
}
var staticRenderFns = []

export { render, staticRenderFns }